<div class="main-reasons">
	<div class="zk-flex zk-gap-1">
		<span class="main-reasons-title">{{
			'CONTACT.MAIN_REASONS' | translate
		}}</span>
		<div freud-tooltip [tooltipLabel]="'CONTACT.MAIN_REASONS_TOOLTIP' | translate">
			<span class="freud-icon freud-icon-info-circle"></span>
		</div>
	</div>
	<span class="main-reasons-description zk-mb-3 zk-block">{{
		mainReasons.length > 0 ? ('CONTACT.MAIN_REASONS_DESCRIPTION' | translate) : ('CONTACT.MAIN_REASONS_EMPTY' | translate)
	}}</span>
	<div class="zk-flex zk-gap-2">
		<div class="reason-tag" *ngFor="let reason of mainReasons">
			{{ reason }}
		</div>
	</div>
</div>
